import React from "react";
import { withRouter } from "react-router-dom";

class Spinner extends React.Component {
  render() {
    const { location } = this.props;
    const isOrderHistoryOrTrackOrder =
  location?.pathname?.toLowerCase().includes("order-history") ||
  location?.pathname?.toLowerCase().includes("track-order");

    const spinnerVisibility = isOrderHistoryOrTrackOrder ? "hidden" : "visible";

    return (
<div
  className="full-width"
  style={{
    position: "fixed",
    top: "80px",
    left: 0,
    height: "calc(100vh - 80px)",
    width: "100vw",
    visibility: spinnerVisibility,
    zIndex: 9999,
    display: "flex",
    backgroundColor: isOrderHistoryOrTrackOrder
      ? "transparent"
      : "rgba(255, 255, 255, 0.29)",
    justifyContent: "center",
    alignItems: "flex-start",
    paddingTop: "30vh",
  }}
>
        <div className="spinner-border spinner-wide-handling" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }
}

export default withRouter(Spinner);
